import { isEmpty } from 'lodash';

import {
    convertObjectToCssVariables,
    DEFAULT_PINNED_STREAM_POSITION,
    DEFAULT_POSITION_PROPS,
    IBettingPinnedStreamPosition,
} from 'styles';

function getPinnedStreamPositionCssVariables(
    positionProps: Required<IBettingPinnedStreamPosition>
): CssVariables {
    if (propsHaveMissingFields(positionProps)) return DEFAULT_POSITION_PROPS;

    const [
        cssPositionProps,
        isAnyPassedPropInvalid,
    ] = convertObjectToCssVariables(positionProps);

    return isAnyPassedPropInvalid ? DEFAULT_POSITION_PROPS : cssPositionProps;
}

function propsHaveMissingFields(
    positionProps: Partial<IBettingPinnedStreamPosition>
): boolean {
    if (isEmpty(positionProps)) {
        console.error(
            'Position variables for PinnedStreamComponent are missing!'
        );

        return true;
    }

    if (!checkAllVariablesProvided(positionProps)) {
        console.error(
            'Position variables for PinnedStreamComponent include not all required fields!'
        );

        return true;
    }

    return false;
}

function checkAllVariablesProvided(
    positionProps: Partial<IBettingPinnedStreamPosition>
): boolean {
    return Object.keys(DEFAULT_PINNED_STREAM_POSITION).every(
        key => key in positionProps
    );
}

export default getPinnedStreamPositionCssVariables;
